import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FieldType } from '@ngx-formly/core';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { CWApi, CWProfile, ExitApi, ExitCandidate, ExitRequest, HttpStatusCode } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { LoaderService } from 'src/app/core/loader.service';
import { ExitAdditionalInfoComponent } from 'src/app/exit/components/exit-additional-info/exit-additional-info.component';
import { InfoTemplateComponent } from 'src/app/exit/components/exit-additional-info/info-template/info-template.component';
import { AdditionalInfoStepService } from 'src/app/exit/services/additional-info-step.service';
import { ActivatedRoute } from '@angular/router';
import { Modules } from '../../module-types';

@Component({
  selector: 'eos-additional-detail-picker',
  templateUrl: './additional-detail-picker.component.html',
  styleUrls: ['./additional-detail-picker.component.css']
})
export class AdditionalDetailPickerComponent extends FieldType implements OnInit {

  formArray: UntypedFormArray
  newModel: any;
  modalRef: any;
  exitType: string;
  module:string;
  path:string;
  steps: any[];
  profileId: number;
  fromCW:boolean=false;


  constructor(private modalService: NgbModal,
    private addSteps: AdditionalInfoStepService,
    public modal: NgbActiveModal,
    private exitApi: ExitApi,
    private cwApi: CWApi,
    private loader: LoaderService,
    private toast: ToastService,
    private activeRoute: ActivatedRoute,
    private common: CommonService) {
    super();
    this.activeRoute.params.subscribe((routeParams) => {
      this.exitType = routeParams.exitType; 
      this.module = Modules.EXIT;   
      this.profileId = routeParams.id;  
    });
    this.activeRoute.data.subscribe((data)=>{
      this.module=data.name;
      this.path =data.path;
    })
    
  }

  ngOnInit() {
    if(this.module == Modules.CW){
      this.formArray = new UntypedFormArray(this.addSteps.GetCWSteps().map(() => new UntypedFormGroup({})));
      if(this.path=='link'){
        this.steps= this.addSteps.GetCWSteps();
        
        this.loadCWData();
      }
    }
    else{
      this.formArray = new UntypedFormArray(this.addSteps.GetSteps(this.exitType).map(() => new UntypedFormGroup({})));
    }
   
  }


  openPickerModel() {
    const picker = this.modalService.open(InfoTemplateComponent, { windowClass: 'dark-modal' });
    this.modalRef = picker;
    if(this.module == Modules.CW){
      this.newModel = new CWProfile(this.model);
      picker.componentInstance.steps = this.addSteps.GetCWSteps();
     
      
    }
    else{
      this.newModel = new ExitRequest(this.model);
      picker.componentInstance.steps = this.addSteps.GetSteps(this.newModel.exitType.value);
      picker.componentInstance.exitType = this.newModel.exitType.value;
    }
    

   
    picker.componentInstance.formArray = this.formArray;
    picker.componentInstance.inModal = true;
    picker.componentInstance.model = this.newModel;
    
    // picker.componentInstance.saveEvent.subscribe(resp => this.onSave(resp, false));
    picker.componentInstance.submitEvent.subscribe(resp => this.onSave(resp, true));

    picker.result.then(closeParam => {
      this.common.updateUI$.next(true);
    }, dismiss => {

    });
  }


  onSave(data: ExitCandidate, isSubmit: boolean) {
    if (this.model.id && this.model.id > 0) {
      data.profile = this.newModel;
      data.profile.allTeamUpdated = this.formArray.valid;
      this.exitApi.saveRequestProcess(isSubmit, data)
        .pipe(finalize(() => this.loader.clear()))
        .subscribe(result => {
          if (result.statusCode == HttpStatusCode.Created) {
            this.toast.success("Saved Sucessfully");
            const data = new ExitRequest(result.data);
            this.modalRef.componentInstance.setModel(data);
          }
        }, err => {
          this.toast.error("Error occured while saving the details!");
        });
    }
  }
  save($event){}
  cwSubmit(event:CWProfile){
    console.log(event)
    this.cwApi.saveRequestProcess(true, this.newModel)
        .pipe(finalize(() => this.loader.clear()))
        .subscribe(result => {
          if (result.statusCode == HttpStatusCode.Created) {
            this.toast.success("Saved Sucessfully");
            this.newModel=result.data;
            this.fromCW=true;

          }
        }, err => {
          this.toast.error("Error occured while saving the details!");
        });
  }
  loadCWData(){
    this.loader.show();
    this.cwApi.getCWProfile(this.profileId).pipe(finalize(() => {
      this.loader.clear();
    })).subscribe(resp => {
      this.newModel=resp;
      this.fromCW=true;
     
    });
  }
}
